export default __webpack_public_path__ + "static/poster-fbe076a9c271fbbac72e7610884251cf.png";